import { useEffect, useState } from 'react'
import { DatePicker, InputNumber, Input, Switch } from 'antd'
import moment from 'moment'
import AceEditor from 'react-ace'
{ TextArea } = Input

extractUrlIfUrl = (val) ->
  if val?.props?.href? then val.props.href else val

export getTypedInputField = (attributeKey, node) ->

  dataType = node.getDataType?(attributeKey)

  [
    InputField,
    extraProps,
    transformProps = (->),
    parseVal = (val) -> val
  ] = (switch dataType
    when 'date'
      [
        DatePicker,
        { showTime: { format: 'HH:mm' }},
        (props) -> { defaultValue: moment(props.value) }
      ]
    when 'double'
      [InputNumber, {}]
    when 'boolean'
      [
        Switch,
        {
          style: { minWidth: '30%' }
          checkedChildren: 'true'
          unCheckedChildren: 'false'
        }, (props) ->
          { checked: props.value }
      ]
    when 'json'
      [
        AceEditor,
        aceProps,
        (props) ->
          _.mapValues({
            value: props.value,
            defaultValue: props.defaultValue
          }, (val) ->
            if _.isObject(val)
              JSON.stringify(val, null, 2)
            else
              val
          )
      ]
    when 'multiline'
      [TextArea, { rows: 3 }]
    else
      [Input, { allowClear: true }]
  )

  ({ updateValue, attributeKey, receivedProps... }) ->

    [value, setValue] = useState(receivedProps.value)

    props = {
      receivedProps...,
      extraProps...,
      value
      (transformProps({ receivedProps..., value }) or [])...,
    }

    <InputField
      className="inline-node-editor-input-field"
      data-testid="inline-node-editor-input-field-#{ attributeKey }"
      size='small'
      onChange={(val) ->
        val?.target?.value? && val = val.target.value
        setValue(val)
        updateValue(val)
      }
      { props... }
    />

aceProps = {
  style:
    margin: '15px'
    borderRadius: '10px'
    width: '400px'
  fontSize: 14
  mode: "json"
  theme: "solarized_light"
  autoScrollEditorIntoView: true
  showGutter: true
  highlightActiveLine: true
  setOptions:
    readOnly: false,
    highlightActiveLine: false,
    highlightGutterLine: false,
    maxLines: 1000,
    autoScrollEditorIntoView: false,
    showLineNumbers: true
}
